import { RBParsedRail } from 'store/railsBuilder/reducer.types';

export enum RailLoadingStatus {
    IDLE = 'IDLE',
    TO_LOAD = 'TO_LOAD',
    LOADING = 'LOADING',
    LOADED = 'LOADED',
    EMPTY = 'EMPTY',
    FAILURE = 'FAILURE',
}

export type OnSetStripeLoadingStatus = (
    stripeId: RBParsedRail['id'],
    status: RailLoadingStatus,
) => void;
